var _line, _line2, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcVest(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 13,
    viewBox: "0 0 11 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1.95064,
    y1: 1.47434,
    x2: 5.47629,
    y2: 12.0513,
    stroke: "#141E2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 0.75,
    y1: -0.75,
    x2: 11.8991,
    y2: -0.75,
    transform: "matrix(-0.316228 0.948683 0.948683 0.316228 10.002 1)",
    stroke: "#141E2F",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.45312 6.25H6.70312V7.75H7.45312V6.25ZM9.45312 7.75C9.86734 7.75 10.2031 7.41421 10.2031 7C10.2031 6.58579 9.86734 6.25 9.45312 6.25V7.75ZM7.45312 7.75H9.45312V6.25H7.45312V7.75Z",
    fill: "#141E2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.55078 7.75H4.30078V6.25H3.55078V7.75ZM1.55078 6.25C1.13657 6.25 0.800781 6.58579 0.800781 7C0.800781 7.41421 1.13657 7.75 1.55078 7.75V6.25ZM3.55078 6.25H1.55078V7.75H3.55078V6.25Z",
    fill: "#141E2F"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcVest);
export default __webpack_public_path__ + "static/media/ic_vest.798ab787d16cdc280cef6763c9fa166d.svg";
export { ForwardRef as ReactComponent };